var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2C6.70156 2 2 6.70156 2 12.5C2 18.2984 6.70156 23 12.5 23C18.2984 23 23 18.2984 23 12.5C23 6.70156 18.2984 2 12.5 2ZM12.5 21.2188C7.68594 21.2188 3.78125 17.3141 3.78125 12.5C3.78125 7.68594 7.68594 3.78125 12.5 3.78125C17.3141 3.78125 21.2188 7.68594 21.2188 12.5C21.2188 17.3141 17.3141 21.2188 12.5 21.2188Z",
    fill: "#FAAD14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3746 16.625C11.3746 16.9234 11.4932 17.2095 11.7041 17.4205C11.9151 17.6315 12.2013 17.75 12.4996 17.75C12.798 17.75 13.0842 17.6315 13.2951 17.4205C13.5061 17.2095 13.6246 16.9234 13.6246 16.625C13.6246 16.3266 13.5061 16.0405 13.2951 15.8295C13.0842 15.6185 12.798 15.5 12.4996 15.5C12.2013 15.5 11.9151 15.6185 11.7041 15.8295C11.4932 16.0405 11.3746 16.3266 11.3746 16.625ZM11.9371 14H13.0621C13.1653 14 13.2496 13.9156 13.2496 13.8125V7.4375C13.2496 7.33438 13.1653 7.25 13.0621 7.25H11.9371C11.834 7.25 11.7496 7.33438 11.7496 7.4375V13.8125C11.7496 13.9156 11.834 14 11.9371 14Z",
    fill: "#FAAD14"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircle);
export default __webpack_public_path__ + "static/media/warningCircle.6db1d3fc.svg";
export { ForwardRef as ReactComponent };